export class ApplicationSetting {
  id: number;
  settingKey: number;
  value: string;
  description: string;
}
